import { createRef, useEffect, useImperativeHandle, useMemo } from 'react';
import PropTypes from 'prop-types';

import { QueryDropdown } from 'basic-components';
import { ReduxService } from 'dashboard-services/services';

const EMPTY_ARRAY = [];
const KeyFilterBody = ({
  disabled,
  fetchMoreKeys,
  groupName = undefined,
  isFetchingKeys,
  isFetchingNextPageKeys,
  isMulti = false,
  keysFromApi = EMPTY_ARRAY,
  name,
  onChange,
  setKeyQuery,
  size = undefined,
  value,
  menuPortalTarget = undefined,
  ref,
  ...props
}) => {
  const keysRaw = useMemo(() => {
          if(isMulti) {
            return value !== "" && ReduxService.nonNullOrUndefined(value) ? String(value).split(',') : EMPTY_ARRAY
          }
          return value !== "" && ReduxService.nonNullOrUndefined(value) ? String(value) : undefined;
        }, [isMulti, value]),
        keysRef = useMemo(() => ref || createRef(), [ref]),
        keys = useMemo(() => isMulti ? keysRaw?.map(c => ({ label: c, value: c })) : keysRaw, [isMulti, keysRaw])

  useEffect(() => {
    keysRef.current?.refreshOptions?.()
  }, [keysRef, groupName])

  useImperativeHandle(ref, () => ({ 
    validateForForm: () => !!value,
    isValid: () => !!value
  }))

  return (
    <QueryDropdown
        {...props}
        defaultValue={keys}
        disabled={disabled}
        fetchNextPage={fetchMoreKeys}
        isFetching={isFetchingKeys || isFetchingNextPageKeys}
        menuPortalTarget={menuPortalTarget || document.body}
        multi={isMulti}
        name={name}
        onChange={onChange}
        onInputChange={setKeyQuery}
        options={keysFromApi}
        ref={keysRef}
        size={size}
    />
  )
}

KeyFilterBody.displayName = "KeyFilterBody"

KeyFilterBody.propTypes = {
  disabled: PropTypes.bool.isRequired,
  fetchMoreKeys: PropTypes.func.isRequired,
  groupName: PropTypes.string,
  isFetchingKeys: PropTypes.bool.isRequired,
  isFetchingNextPageKeys: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  keysFromApi: PropTypes.array,
  menuPortalTarget: PropTypes.any,
  name: PropTypes.string.isRequired, 
  onChange: PropTypes.func.isRequired,
  setKeyQuery: PropTypes.func.isRequired,
  size: PropTypes.string,
  value: PropTypes.any.isRequired
}

export default KeyFilterBody;
